















// This component is typically used as a dynamic component inside ModalWrapperComponent

import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { StoryUser } from '../StoryUser';
import { Story } from '../Story';
import { QuestionSet, Question } from '../Question';
import * as utils from '../utils';
import * as utils_auth from '../utils_auth';
import { RawLocation } from 'vue-router';
import { globalUC } from '../UserCache';

interface selectOption { text?: string, html?: string, value: string, disabled?: boolean}

@Component({
  name: 'ChooseQuestionComponent',
  components: {}
})
export default class ChooseQuestionComponent extends Vue {
  // prop reactive member variables publically available to the html template
  @Prop({ default: 'Cancel' })
  public cancelBtnText: string

  @Prop({ default: 'Choose this One' })
  public okBtnText: string

  // public reactive member variables available to the html template
  public questions: QuestionSet[] = null
  public storyTellerId: string = null
  public storyTeller: StoryUser = null
  public chosenQuestion: string = null      // format of question.id + '///' + question.text

  // public functions available to the html template
  public get loading(): boolean { return this.$store.state.loading }
  public get user(): StoryUser { return this.$store.getters.userObject }

  public createSelectOptionFromQuestion(question: Question): selectOption {
    return {
      text: question.text,
      html: null,
      value: question.id + '///' + question.text,
      disabled: false
    }
  }
  public createSelectOptionsFromQuestionSet(questionSet: QuestionSet): selectOption[] {
    const sos: selectOption[] = []
    sos.push({
      text: null,
      html: `<b>${questionSet.category}</b>`,
      value: null,
      disabled: false
    })
    for (const question of questionSet.questions) sos.push(this.createSelectOptionFromQuestion(question))
    return sos
  }

  public onCancel() {
    this.$emit('close', null)
  }
  public async onShow(dynamicProps: { storyTellerId?: string }) {
    this.storyTellerId = dynamicProps ? dynamicProps.storyTellerId : null

    if (this.storyTellerId) {
      this.$store.commit('setLoading', { loading: true });
      this.storyTeller = await globalUC.get(this.storyTellerId, false)
      this.$store.commit('setLoading', { loading: false });
    } else {
      this.storyTeller = null
    }
  }
  public async onOK() {
    this.$emit('close', this.chosenQuestion)
  }

  // private, non-reactive member variables

  // private functions not available directly to HTML template
  private async mounted() {
    if (this.$store.state.devmode) console.log(`${this.$options.name} mounted()`)

    // @ts-ignore: because segment analytics is loaded in head script
    window.analytics.page(this.$options.name)

    this.fetchData()
  }
  private async beforeDestroy() { if (this.$store.state.devmode) console.log(`${this.$options.name} beforeDestroy()`) }

  private async fetchData(): Promise<void> {
    if (!this.user) return

    // make GET call to server
    try {
      this.$store.commit('setLoading', { loading: true });
      const url: string = utils.getURLprefix() + '/api/utils/questions';
      const response: any = await utils.makeGetCall(url);
      if (!response || !response.data) throw(new Error('ChooseQuestionComponent.fetchData() got null response or null response.data'))
      if (response.data.error) {
        this.$store.commit('setLoading', { loading: false });
        utils.toast(this, 'Error', response.data.error)
      }
      if (response.data.questions) {
        // success
        this.questions = response.data.questions
        for (const qs of this.questions) qs.questions = qs.questions.map((q) => new Question(q))
      }

    } catch (error) {
      utils.toast(this, 'System Error', 'Could not load questions')
      if (this.$store.state.devmode) console.error(error);
    } finally {
      this.$store.commit('setLoading', { loading: false });
    }
  }
}

